import React from "react";
import PropTypes from "prop-types";
import tw from "twin.macro";

const Wrapper = tw.div`bg-gray-100 text-gray-900 py-8`;
const Content = tw.div`container mx-auto`;

const Foundation = ({ children }) => (
  <Wrapper>
    <Content>{children}</Content>
  </Wrapper>
);

Foundation.propTypes = {
  children: PropTypes.node
};

export default Foundation;
